import type { ApiResponse } from "@nelurio/contracts";

const API_BASE = import.meta.env.VITE_API_BASE_URL || "/api/v1";
const CSRF_KEY = "nelurio.admin.csrf";

export async function adminApi<T>(path: string, options: RequestInit = {}): Promise<T> {
  const method = (options.method || "GET").toUpperCase();
  const headers = new Headers(options.headers);
  if (options.body && !headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  if (!["GET","HEAD","OPTIONS"].includes(method)) {
    const csrf = localStorage.getItem(CSRF_KEY);
    if (csrf) headers.set("X-CSRF-Token", csrf);
  }
  const response = await fetch(`${API_BASE}/admin${path}`, { ...options, headers, credentials: "include" });
  const payload = await response.json().catch(() => null);
  if (!response.ok) throw new Error(payload?.error?.message || response.statusText);
  const csrf = response.headers.get("x-csrf-token") || payload?.meta?.csrfToken;
  if (csrf) localStorage.setItem(CSRF_KEY, csrf);
  return (payload as ApiResponse<T>)?.data ?? payload;
}
